<template>
  <vf-size-picker v-bind="forwarded">
    <slot />
  </vf-size-picker>
</template>

<script lang="ts" setup>
import type { Props } from '#brands/components/vf/size-picker/SizePicker.vue'
import VfSizePicker from '#brands/components/vf/size-picker/SizePicker.vue'

const props = defineProps<Props>()

const { $feature } = useNuxtApp()

const { brandClasses } = useAppConfig().components.vf.sizePicker
const forwarded = useForwardProps(props)

if ($feature.tempShowATCAboveFold)
  brandClasses.sizeMd = 'min-h-12 min-w-20 lg:min-h-10 lg:min-w-12'
</script>
